module.exports = "<input [formControl]=\"valueControl\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/filter-input/filter-input.component.html
// module id = 426
// module chunks = 0